import { render, staticRenderFns } from "./EditarLaboratoriosView.vue?vue&type=template&id=706d8575"
import script from "./EditarLaboratoriosView.vue?vue&type=script&lang=js"
export * from "./EditarLaboratoriosView.vue?vue&type=script&lang=js"
import style0 from "./EditarLaboratoriosView.vue?vue&type=style&index=0&id=706d8575&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports